/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateShadowMCPInventoryServerNameForm,
  UpdateShadowMCPInventoryServerNameForm$Outbound,
  UpdateShadowMCPInventoryServerNameForm$outboundSchema,
} from "../components/updateshadowmcpinventoryservernameform.js";

export type UpdateShadowMCPInventoryServerNameSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type UpdateShadowMCPInventoryServerNameRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  updateShadowMCPInventoryServerNameForm:
    UpdateShadowMCPInventoryServerNameForm;
};

/** @internal */
export type UpdateShadowMCPInventoryServerNameSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const UpdateShadowMCPInventoryServerNameSecurity$outboundSchema:
  z.ZodMiniType<
    UpdateShadowMCPInventoryServerNameSecurity$Outbound,
    UpdateShadowMCPInventoryServerNameSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function updateShadowMCPInventoryServerNameSecurityToJSON(
  updateShadowMCPInventoryServerNameSecurity:
    UpdateShadowMCPInventoryServerNameSecurity,
): string {
  return JSON.stringify(
    UpdateShadowMCPInventoryServerNameSecurity$outboundSchema.parse(
      updateShadowMCPInventoryServerNameSecurity,
    ),
  );
}

/** @internal */
export type UpdateShadowMCPInventoryServerNameRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  UpdateShadowMCPInventoryServerNameForm:
    UpdateShadowMCPInventoryServerNameForm$Outbound;
};

/** @internal */
export const UpdateShadowMCPInventoryServerNameRequest$outboundSchema:
  z.ZodMiniType<
    UpdateShadowMCPInventoryServerNameRequest$Outbound,
    UpdateShadowMCPInventoryServerNameRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      updateShadowMCPInventoryServerNameForm:
        UpdateShadowMCPInventoryServerNameForm$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        updateShadowMCPInventoryServerNameForm:
          "UpdateShadowMCPInventoryServerNameForm",
      });
    }),
  );

export function updateShadowMCPInventoryServerNameRequestToJSON(
  updateShadowMCPInventoryServerNameRequest:
    UpdateShadowMCPInventoryServerNameRequest,
): string {
  return JSON.stringify(
    UpdateShadowMCPInventoryServerNameRequest$outboundSchema.parse(
      updateShadowMCPInventoryServerNameRequest,
    ),
  );
}
